import { Stack, styled, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import DirectionIcon from '../../../../assets/icons/directionIcon.svg?react';

import { ROUTES } from '../../../../constants/routes';
import { StationCardProps } from './types';
import { CardStatus } from '../CardStatus/CardStatus';
import { StyledGreenSpan } from '../../StyledGreenSpan/StyledGreenSpan';
import { theme } from '../../../../theme/ThemeProvider';

const StyledLink = styled(Link)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
  borderRadius: '15px',
  padding: '14px',
  border: '1px solid',
  borderColor: theme.palette.gray[150],
  textDecoration: 'none',
  color: 'inherit',
}));

export const StationCard: React.FC<StationCardProps> = ({ data }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <StyledLink
      to={`/${ROUTES.CABINET}/${ROUTES.CAB_STATION}/${data.station_id}`}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="body1" color="common.white">
          {data.address}
        </Typography>

        <DirectionIcon width={22} color={theme.palette.green.main} />
      </Stack>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="body1" color="common.white">
          {t('stationPageWithSearch.code')}:{' '}
          <StyledGreenSpan>{data.code}</StyledGreenSpan>
        </Typography>
      </Stack>
      {data.connectorTypes?.length ? (
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="body1" color="common.white">
            {t('stationPageWithSearch.connectorsTypes')}:{' '}
            {data.connectorTypes.map((type) => (
              <>
                <br />
                <StyledGreenSpan key={type}>{type}</StyledGreenSpan>
              </>
            ))}
          </Typography>
        </Stack>
      ) : null}

      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="body1" color="common.white">
          {t('orderPage.pricing')}:{' '}
          <StyledGreenSpan>
            {data.price} ₴/{t('orderPage.energyUnit')}
          </StyledGreenSpan>
        </Typography>
        <CardStatus chargingStatus={data.status} text="statuses.station" />
      </Stack>
    </StyledLink>
  );
};
